export const baseUrl = "https://ihris-demo.moh.gov.et/hrl/api";
